// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of Thicknesses
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## Thicknesses Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Thicknesses.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## Thicknesses Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Thicknesses.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Thicknesses Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Thicknesses.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Thicknesses Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(Endpoints.Thicknesses.Update(option), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## Thicknesses Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Thicknesses.Delete(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
